import { gql } from '@apollo/client';

export const GET_ORDER_DETAIL = gql`
    query getOrder($input: QueryOrderInput!) {
        myOrder(input: $input) {
            data {
                id
                userId
                creator
                created
                updater
                updated
                status
                statusDetail {
                    status
                    description
                    displayStr
                }
                orderPlacedDate
                payment {
                    id
                    userId
                    entityId
                    paymentMethod
                    paymentBrands
                    userPayment {
                        givenName
                        surname
                    }
                    card {
                        last4Digits
                    }
                    billing {
                        street1
                        street2
                        city
                        state
                        postcode
                        country
                    }
                    status
                    paid
                    code
                    checkoutId
                    creator
                    created
                    updater
                    updated
                }
                taffiId
                taxPercentage
                items {
                    data {
                        id
                        type
                        taffiId
                        price
                        currency
                        available
                        title
                        description
                        url
                        images
                        maxNumOfStyles
                        maxNumOfItems
                        creator
                        created
                        updater
                        updated
                        storeId
                    }
                    id
                    quantity
                    status
                    statusDetail {
                        status
                        description
                        displayStr
                    }
                    type
                    contextDetail
                    currency
                    size
                    color
                    price
                }
                deliveryAddress {
                    userId
                    creator
                    created
                    updater
                    updated
                    firstName
                    lastName
                    countryCode
                    countryName
                    address
                    city
                    province
                    postalCode
                    phoneNumber
                }
            }
        }
    }
`;

export const GET_ORDER_DETAIL_BY_USERNAME = gql`
    query GetOrderByUserName($input: QueryGetOrderByUserNameInput!) {
        getOrderByUserName(input: $input) {
            data {
                id
                userId
                creator
                created
                updater
                updated
                status
                statusDetail {
                    status
                    description
                    displayStr
                }
                orderPlacedDate
                payment {
                    id
                    userId
                    entityId
                    paymentMethod
                    paymentBrands
                    userPayment {
                        givenName
                        surname
                    }
                    card {
                        last4Digits
                    }
                    billing {
                        street1
                        street2
                        city
                        state
                        postcode
                        country
                    }
                    status
                    paid
                    code
                    checkoutId
                    creator
                    created
                    updater
                    updated
                }
                taffiId
                taxPercentage
                items {
                    data {
                        id
                        type
                        taffiId
                        price
                        currency
                        available
                        title
                        description
                        url
                        images
                        maxNumOfStyles
                        maxNumOfItems
                        creator
                        created
                        updater
                        updated
                        storeId
                    }
                    id
                    quantity
                    status
                    statusDetail {
                        status
                        description
                        displayStr
                    }
                    type
                    contextDetail
                    currency
                    size
                    color
                    price
                }
                deliveryAddress {
                    userId
                    creator
                    created
                    updater
                    updated
                    firstName
                    lastName
                    countryCode
                    countryName
                    address
                    city
                    province
                    postalCode
                    phoneNumber
                }
            }
        }
    }
`;

export const GET_ORDER_ITEM_IDS = gql`
    query getOrder($input: QueryOrderInput!) {
        myOrder(input: $input) {
            data {
                id
                userId
                creator
                created
                updater
                updated
                status
                orderPlacedDate
                taffiId
                items {
                    id
                    size
                    color
                }
            }
        }
    }
`;

export const GET_INVOICE = gql`
    query GetInvoice($input: QueryGetInvoiceInput!) {
        getInvoice(input: $input) {
            invoiceFileUrl
        }
    }
`;
export const GET_ORDER_ITEM_IDS_BY_USERNAME = gql`
    query GetOrderByUserName($input: QueryGetOrderByUserNameInput!) {
        getOrderByUserName(input: $input) {
            data {
                id
                userId
                creator
                created
                updater
                updated
                status
                orderPlacedDate
                taffiId
                items {
                    id
                    size
                    color
                }
            }
        }
    }
`;
